/**
 * Sales Convert PDP — variants, volume tiers, per-product promo codes, sticky ATC
 */
(function () {
  function money(cents, format) {
    var amount = (Number(cents) / 100).toFixed(2);
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format || '${{amount}}');
    }
    if (format && format.indexOf('{{') !== -1) {
      return format
        .replace(/\{\{\s*amount\s*\}\}/g, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(Number(cents) / 100)));
    }
    return '$' + amount;
  }

  function parseTiers(root) {
    try {
      var node = root.querySelector('[data-sc-tiers-json]') || document.querySelector('[data-sc-tiers-json]');
      if (node && node.textContent) return JSON.parse(node.textContent);
      if (root.dataset.scTiers) return JSON.parse(root.dataset.scTiers);
      return [];
    } catch (e) {
      return [];
    }
  }

  function bestTier(tiers, qty) {
    var best = null;
    tiers.forEach(function (t) {
      if (qty >= t.qty && (!best || t.qty >= best.qty)) best = t;
    });
    return best;
  }

  function initRoot(root) {
    if (!root || root.dataset.scInit === '1') return;
    root.dataset.scInit = '1';

    var form = root.querySelector('[data-sc-form]');
    var variantInput = root.querySelector('[data-sc-variant-id]');
    var qtyInput = root.querySelector('[data-sc-qty]');
    var priceEls = root.querySelectorAll('[data-sc-price]');
    var stickyBtn = root.querySelector('[data-sc-sticky-atc]');
    var stickyPrice = root.querySelector('[data-sc-sticky-price]');
    var addBtns = root.querySelectorAll('[data-sc-add]');
    var viewingEl = root.querySelector('[data-sc-viewing]');
    var track = root.querySelector('[data-sc-media-track]');
    var dots = root.querySelectorAll('[data-sc-dot]');
    var moneyFormat = root.dataset.moneyFormat || '{{amount}}';
    var tiers = parseTiers(root);
    var promoText = root.querySelector('[data-sc-promo-text]');
    var promoCodeEl = root.querySelector('[data-sc-promo-code]');
    var promoCopy = root.querySelector('[data-sc-copy]');
    var saveEl = root.querySelector('[data-sc-save-line]');
    var unitEl = root.querySelector('[data-sc-unit-price]');

    if (viewingEl) {
      var pid = root.dataset.productId || '0';
      var day = new Date().toISOString().slice(0, 10);
      var key = 'sc_view_' + pid + '_' + day;
      var n = parseInt(localStorage.getItem(key) || '0', 10);
      if (!n) {
        n = 120 + Math.floor(Math.random() * 180);
        localStorage.setItem(key, String(n));
      }
      viewingEl.textContent = String(n);
    }

    function selectedVariant() {
      var checked = root.querySelector('.sc-variant input:checked');
      if (checked) {
        return {
          id: checked.value,
          price: parseInt(checked.dataset.price || '0', 10),
          compare: parseInt(checked.dataset.compare || '0', 10),
          available: checked.dataset.available !== 'false',
        };
      }
      // single-variant products
      if (variantInput) {
        return {
          id: variantInput.value,
          price: parseInt(root.dataset.scPrice || '0', 10),
          compare: parseInt(root.dataset.scCompare || '0', 10),
          available: root.dataset.scAvailable !== 'false',
        };
      }
      return null;
    }

    function currentQty() {
      return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    }

    function syncPromo(tier) {
      if (!tier) {
        if (promoText) promoText.textContent = root.dataset.scPromoIdle || 'Volume discounts available';
        if (promoCodeEl) promoCodeEl.textContent = '';
        if (promoCopy) {
          promoCopy.dataset.scCopy = '';
          promoCopy.hidden = true;
        }
        return;
      }
      if (promoText) {
        promoText.textContent =
          'Buy ' + tier.qty + ' & Get ' + tier.pct + '% OFF';
      }
      if (promoCodeEl) {
        promoCodeEl.innerHTML = 'Use code: <strong>' + tier.code + '</strong>';
      }
      if (promoCopy) {
        promoCopy.dataset.scCopy = tier.code;
        promoCopy.hidden = false;
      }
      // keep hidden input for cart properties
      var codeInput = root.querySelector('[data-sc-discount-prop]');
      if (codeInput) codeInput.value = tier.code;
    }

    function syncBulkActive(qty) {
      root.querySelectorAll('[data-sc-bulk-qty]').forEach(function (chip) {
        var q = parseInt(chip.dataset.scBulkQty || '0', 10);
        chip.classList.toggle('is-active', q === qty);
      });
    }

    function syncPrice() {
      var v = selectedVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;

      var qty = currentQty();
      var tier = bestTier(tiers, qty);
      var unit = v.price;
      var discountedUnit = unit;
      if (tier && tier.pct > 0) {
        discountedUnit = Math.round(unit * (100 - tier.pct) / 100);
      }
      var lineTotal = discountedUnit * qty;
      var formatted = money(lineTotal, moneyFormat);
      var unitFormatted = money(discountedUnit, moneyFormat);

      priceEls.forEach(function (el) {
        el.textContent = formatted;
      });
      if (stickyPrice) stickyPrice.textContent = formatted;
      if (unitEl) unitEl.textContent = qty > 1 ? unitFormatted + ' each' : '';
      if (saveEl) {
        if (tier && discountedUnit < unit) {
          var saved = (unit - discountedUnit) * qty;
          saveEl.textContent = 'You save ' + money(saved, moneyFormat) + ' (' + tier.pct + '% off)';
          saveEl.hidden = false;
        } else {
          saveEl.textContent = '';
          saveEl.hidden = true;
        }
      }

      syncPromo(tier || (tiers[0] || null));
      if (tier) syncBulkActive(tier.qty);
      else syncBulkActive(-1);

      var disabled = !v.available;
      addBtns.forEach(function (btn) {
        btn.disabled = disabled;
        if (btn.dataset.labelAvailable) {
          btn.textContent = disabled
            ? btn.dataset.labelSoldout || 'Sold out'
            : btn.dataset.labelAvailable;
        }
      });
      if (stickyBtn) {
        stickyBtn.disabled = disabled;
        stickyBtn.textContent = disabled
          ? stickyBtn.dataset.labelSoldout || 'Sold out'
          : stickyBtn.dataset.labelAvailable || 'Add to cart';
      }
    }

    root.querySelectorAll('.sc-variant input').forEach(function (input) {
      input.addEventListener('change', function () {
        root.querySelectorAll('.sc-variant').forEach(function (card) {
          card.classList.toggle('is-selected', card.querySelector('input') === input);
        });
        syncPrice();
      });
    });

    function bumpQty(delta) {
      if (!qtyInput) return;
      var min = parseInt(qtyInput.min || '1', 10);
      var max = parseInt(qtyInput.max || '99', 10);
      var val = Math.min(max, Math.max(min, (parseInt(qtyInput.value, 10) || min) + delta));
      qtyInput.value = String(val);
      syncPrice();
    }

    root.querySelectorAll('[data-sc-qty-dec]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        bumpQty(-1);
      });
    });
    root.querySelectorAll('[data-sc-qty-inc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        bumpQty(1);
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('change', syncPrice);
      qtyInput.addEventListener('input', syncPrice);
    }

    root.querySelectorAll('[data-sc-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var code = btn.dataset.scCopy || '';
        if (!code) return;
        var done = function () {
          var prev = btn.textContent;
          btn.textContent = btn.dataset.copiedLabel || 'Copied';
          setTimeout(function () {
            btn.textContent = prev;
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(done);
        } else {
          done();
        }
      });
    });

    if (track && dots.length) {
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
    }

    if (stickyBtn && form) {
      stickyBtn.addEventListener('click', function () {
        if (stickyBtn.disabled) return;
        var nativeSubmit = form.querySelector('[type="submit"]');
        if (nativeSubmit) nativeSubmit.click();
        else if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });
    }

    root.querySelectorAll('[data-sc-bulk-qty]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (!qtyInput) return;
        qtyInput.value = chip.dataset.scBulkQty || '1';
        syncPrice();
      });
    });

    syncPrice();
  }

  function boot() {
    document.querySelectorAll('[data-sc-pdp]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('[data-sc-pdp]');
    if (root) {
      root.dataset.scInit = '';
      initRoot(root);
    }
  });
})();
